import {STEPS} from '../../../constants'

// ------------------------------------
// Constants
// ------------------------------------
const STEP_CHANGE = 'STEP_CHANGE';

// ------------------------------------
// Actions
// ------------------------------------
function changeStep(value = '') {
  return {
    type    : STEP_CHANGE,
    payload : value
  }
}

export {
  changeStep
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [STEP_CHANGE]  : (state, action) => action.payload,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = STEPS.CATEGORIES;

export default function stepReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/layouts/Content/modules/step.js